(() => {
  const body = document.body;
  if (!body) return;
  body.classList.add('ei-service-site');

  const progress = document.createElement('div');
  progress.className = 'ei-reading-line';
  progress.setAttribute('aria-hidden', 'true');
  body.appendChild(progress);

  const updateProgress = () => {
    const available = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.width = `${available > 0 ? Math.min(100, (window.scrollY / available) * 100) : 0}%`;
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);

})();
